import { render, staticRenderFns } from "./RenameTemplateForm.vue?vue&type=template&id=5452618f&scoped=true"
import script from "./RenameTemplateForm.vue?vue&type=script&lang=js"
export * from "./RenameTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./RenameTemplateForm.vue?vue&type=style&index=0&id=5452618f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452618f",
  null
  
)

export default component.exports